import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/CancelOutlined";
import { HelpOutlineOutlined } from "@mui/icons-material";

/**
 * StatusChip
 *
 * status === 1 → Pass
 * status === 0 → Fail
 */
const StatusChip = ({ status }) => {
  // status === 2 always means pass.
  const localStatus = status === 2 ? 1 : status
  const style = statusStyle[localStatus] || statusStyle[3];
  return (
    <Box
      sx={{
        ...baseContainerStyle,
        backgroundColor: style.bgColor,
      }}
    >
      {localStatus === 1 ? (
        <CheckCircleIcon sx={{ color: style.iconColor, fontSize: 12 }} />
      ) : localStatus === 0 ? (
        <CancelIcon sx={{ color: style.iconColor, fontSize: 12 }} />
      ) : (
        <HelpOutlineOutlined sx={{ color: style.iconColor, fontSize: 12 }} />
      )}
      <Typography variant="h6" sx={{ color: style.textColor }}>
        {style.label}
      </Typography>
    </Box>
  );
};

export default React.memo(StatusChip);
const statusStyle = {
  1: {
    bgColor: "#D1FADF",
    textColor: "#027A48",
    iconColor: "#027A48",
    label: "Pass",
  },
  0: {
    bgColor: "#FEF3F2",
    textColor: "#B42318",
    iconColor: "#B42318",
    label: "Fail",
  },
  3: {
    bgColor: "#F5F5F5",
    textColor: "#414651",
    iconColor: "#414651",
    label: "Absent",
  },
};

const baseContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 0.5,
  borderRadius: "24px",
  p: 0.25,
  px: 1,
  width: "fit-content",
};
